import PublicHeader from "../components/PublicHeader";

const CGVPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <PublicHeader />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight text-[#09090B] mb-8" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Conditions Générales de Vente
        </h1>

        <div className="space-y-8 text-sm text-zinc-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 1 — Objet</h2>
            <p>Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre la société <strong>MICRO MULTIMÉDIA BERGEVIN</strong> (SASU), ci-après dénommée « le Prestataire », et toute personne physique ou morale, ci-après dénommée « le Client », effectuant un achat de produit ou faisant appel à un service de réparation proposé en boutique ou sur le site <strong>micromultimedia.fr</strong>.</p>
            <p className="mt-2">Toute commande ou dépôt d'appareil implique l'acceptation sans réserve des présentes CGV.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 2 — Produits et services</h2>
            <p>Le Prestataire propose :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>La vente d'accessoires et de produits informatiques neufs et reconditionnés</li>
              <li>Le service après-vente (SAV) : diagnostic, réparation de smartphones, tablettes, ordinateurs et imprimantes</li>
              <li>La distribution d'abonnements Canal+, Canalbox et TV Caraïbes</li>
              <li>Le service d'impression et de copie</li>
            </ul>
            <p className="mt-2">Les produits sont proposés dans la limite des stocks disponibles.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 3 — Tarifs</h2>
            <p>Les prix sont indiqués en euros (€) toutes taxes comprises (TTC). Le Prestataire se réserve le droit de modifier ses prix à tout moment, étant entendu que le prix facturé au Client sera celui en vigueur au moment de la validation de la commande ou du dépôt de l'appareil.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 4 — Prise en charge SAV</h2>
            <p>Le dépôt d'un appareil pour réparation se fait <strong>exclusivement en boutique</strong>. Des frais de prise en charge (diagnostic inclus) sont appliqués au moment du dépôt :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Téléphone : 15 €</li>
              <li>Tablette : 19 €</li>
              <li>Imprimante : 22 €</li>
              <li>Ordinateur : 27 €</li>
            </ul>
            <p className="mt-2"><strong>Ces frais sont déduits du montant de la réparation si celle-ci est acceptée par le Client.</strong></p>
            <p className="mt-2">En cas de refus du devis par le Client, les frais de prise en charge restent acquis au Prestataire en contrepartie du diagnostic effectué.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 5 — Devis et réparation</h2>
            <p>Après diagnostic, un devis détaillé est remis au Client. Le Client dispose d'un délai de <strong>30 jours</strong> pour accepter ou refuser le devis. Passé ce délai, le Prestataire se réserve le droit de facturer des frais de gardiennage.</p>
            <p className="mt-2">En cas d'acceptation, la réparation est effectuée dans un délai moyen de <strong>48 heures</strong>, sous réserve de la disponibilité des pièces détachées.</p>
            <p className="mt-2">Le Client est notifié par email lorsque son appareil est prêt à être récupéré.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 6 — Garantie réparation</h2>
            <p>Les réparations effectuées par le Prestataire sont couvertes par une garantie pièces et main-d'œuvre d'une durée de <strong>3 mois</strong> à compter de la date de restitution.</p>
            <p className="mt-2">Cette garantie ne couvre pas :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Les dommages résultant d'une mauvaise utilisation, d'un choc ou d'une exposition à l'eau</li>
              <li>Les pannes liées à un composant différent de celui réparé</li>
              <li>Les appareils ayant été ouverts ou modifiés par un tiers après la réparation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 7 — Récupération des appareils</h2>
            <p>Le Client dispose d'un délai de <strong>3 mois</strong> après notification pour récupérer son appareil en boutique. Passé ce délai, le Prestataire ne pourra être tenu responsable de la conservation de l'appareil.</p>
            <p className="mt-2 font-medium">Adresse de retrait : Super U de Bergevin, 97110 Pointe-à-Pitre</p>
            <p className="mt-1">Horaires : Lun, Mar, Jeu, Ven : 8h - 14h | Sam : 9h - 13h | Fermé Mer et Dim</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 8 — Commandes en ligne</h2>
            <p>Les produits commandés en ligne sur micromultimedia.fr sont à <strong>retirer exclusivement en boutique</strong>. Aucune livraison n'est proposée.</p>
            <p className="mt-2">Le paiement en ligne est sécurisé par <strong>Stripe</strong>. Le Client reçoit un email de confirmation après chaque commande.</p>
            <p className="mt-2">Le Client dispose d'un délai de <strong>14 jours</strong> à compter du retrait pour exercer son droit de rétractation, conformément à la législation en vigueur. Le produit doit être retourné dans son état d'origine, non utilisé et dans son emballage d'origine.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 9 — Moyens de paiement</h2>
            <p>Les moyens de paiement acceptés sont :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Espèces</li>
              <li>Carte bancaire (en boutique et en ligne via Stripe)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 10 — Responsabilité</h2>
            <p>Le Prestataire s'engage à apporter tout le soin nécessaire à la réparation des appareils confiés. Toutefois, sa responsabilité est limitée au montant de la réparation en cas de dommage survenu lors de l'intervention.</p>
            <p className="mt-2">Le Prestataire ne saurait être tenu responsable des données contenues dans les appareils confiés. Il est recommandé au Client d'effectuer une sauvegarde de ses données avant tout dépôt.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 11 — Protection des données</h2>
            <p>Les données personnelles collectées sont traitées conformément au Règlement Général sur la Protection des Données (RGPD). Elles sont utilisées uniquement pour la gestion des commandes, du suivi SAV et de la relation client. Pour plus d'informations, consultez nos <a href="/mentions-legales" className="text-[#0055FF] hover:underline">Mentions Légales</a>.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 12 — Litiges</h2>
            <p>Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire. À défaut d'accord, les tribunaux de Pointe-à-Pitre seront seuls compétents.</p>
            <p className="mt-2">Conformément aux dispositions du Code de la consommation, le Client peut recourir gratuitement au service de médiation de la consommation.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#09090B] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>Article 13 — Contact</h2>
            <p>Pour toute question relative aux présentes CGV :</p>
            <ul className="mt-2 space-y-1">
              <li><strong>Email :</strong> <a href="mailto:micro.pc971@gmail.com" className="text-[#0055FF] hover:underline">micro.pc971@gmail.com</a></li>
              <li><strong>Téléphone :</strong> 05 90 89 56 35 (fixe) / 06 90 57 47 28 (mobile)</li>
              <li><strong>Adresse :</strong> Super U de Bergevin, 97110 Pointe-à-Pitre, Guadeloupe</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
